const system_limit = {
    limit_exceeded: 'Du hast das Systemlimit erreicht. Bitte wende dich an den Support, um Hilfe zu erhalten.',
};
export default Object.freeze(system_limit);
